import React, { FC } from 'react';

interface BasicButtonProps {
  className?: string;
  handleClick: () => void | undefined;
}

const defaultProps = {
  className: undefined,
};

export const BasicButton: FC<BasicButtonProps> = ({ handleClick, children, className }) => {
  const handleKeyPress = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.code === 'Enter') {
      handleClick();
    }
  };

  return (
    <div role="button" tabIndex={0} className={className} onClick={handleClick} onKeyPress={handleKeyPress}>
      {children}
    </div>
  );
};

BasicButton.defaultProps = defaultProps;
